import CUSTOM_SECTION_CONTAINER_NAMES from '@src/quince-site-common/src/constants/customSectionContainerNames'
import CUSTOM_SECTION_CONTAINER_TYPES from '@src/quince-site-common/src/constants/customSectionContainerTypes'
import { TrackingMetaData } from '@src/quince-site-common/src/domains/CustomSection'

export const getTrackingMetaData = (): TrackingMetaData => ({
  context: {
    contentContainerType: CUSTOM_SECTION_CONTAINER_TYPES.PRODUCT_DISPLAY,
    contentContainerName: CUSTOM_SECTION_CONTAINER_NAMES.INFINITE_LIST,
    // eslint-disable-next-line i18next/no-literal-string
    contentContainerDisplayName: 'Search Results',
    trackingId: 'searchResults',
  },
})

export const SEARCH_TRACKER = 'searchPage__search_section'
export const PRODUCT_VIEW_TRACKER = 'searchPage__search_section__search_results'
export const SEARCH_WATCHED_QUERY_KEYS: ('q' | 'filter')[] = ['q', 'filter']

export const SEARCH_LIMIT = 40
export const PRODUCT_CARD_OPTION_LIMIT = 5
export const PRODUCTS_LIMIT_FOR_EVENT = 20
